import {EMOTORAD__EVENT_CONTAINER__TEST_RIDES_COUNT__COLUMN_ID} from "~/domainModels/workspaceSpecific/emotorad";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export function isEmotoradJourneyTestRideCountColumnField(columnFieldId: Uuid): boolean {
    return String(columnFieldId) === String(EMOTORAD__EVENT_CONTAINER__TEST_RIDES_COUNT__COLUMN_ID);
}

export function isEmotoradTestRideCountJourneyColumnDisplayName(displayName: string): boolean {
    const normalized = displayName.trim().toLowerCase().replaceAll(/\s+/g, " ");
    const normalizedNeedles = new Set(["test ride count", "testride count", "test rides count"]);
    return normalizedNeedles.has(normalized);
}

function journeyTestRideCountRawToCellString(raw: unknown): string {
    if (raw === undefined || raw === null) {
        return "";
    }
    if (typeof raw === "string") {
        return raw.trim();
    }
    if (typeof raw === "number" && Number.isNaN(raw) === false) {
        return String(raw);
    }
    if (typeof raw === "boolean") {
        return raw === true ? "1" : "0";
    }
    return "";
}

/**
 * Journey-level test ride count for Emotorad tables: prefer the canonical column id, then the
 * configured column field (same pattern as {@link customerTableViewColumnsToOttopilotColumns} for customers).
 */
export function emotoradJourneyTestRideCountCellString(
    journeyAdditionalColumnValues: Record<Uuid, unknown>,
    columnFieldId: Uuid,
): string {
    const fromCanonical = journeyAdditionalColumnValues[EMOTORAD__EVENT_CONTAINER__TEST_RIDES_COUNT__COLUMN_ID];
    const fromCanonicalText = journeyTestRideCountRawToCellString(fromCanonical);
    if (fromCanonicalText !== "") {
        return fromCanonicalText;
    }
    const fromConfigured = journeyAdditionalColumnValues[columnFieldId];
    const fromConfiguredText = journeyTestRideCountRawToCellString(fromConfigured);
    return fromConfiguredText === "" ? "0" : fromConfiguredText;
}
